import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from 'amphitheatre';
import QFBTheme from '../../Theme';
import Board, { Content, Image, Topbar } from './UpdateBoard.styled';

const { Header, Paragraph } = Typography;

const TitleStyle: React.CSSProperties = {
  fontWeight: 'bold',
  textTransform: 'uppercase',
};

const DateStyle: React.CSSProperties = {
  color: QFBTheme.qfb5,
  fontFamily: 'Lato',
  fontSize: '0.9rem',
  textAlign: 'right',
  marginBottom: '0',
};

interface Props {
  title: string;
  excerpt: string;
  img: string;
  link?: string;
  date?: string;
}

const UpdateBoard: React.FunctionComponent<Props> = ({
  title,
  excerpt,
  img,
  link,
  date,
}: Props) => {
  if (link) {
    return (
      <Board>
        <Link to={`${link}`}>
          <Topbar />
          <Image src={img} />
          <Content>
            <div className="not-footer">
              <Header level={5} style={TitleStyle}>
                {title}
              </Header>
              <Paragraph>{excerpt}</Paragraph>
              <Paragraph>
                <span style={{ color: '#baace8' }}>Read More</span>
              </Paragraph>
            </div>
            {date ? (
              <Header level={5} style={DateStyle}>
                {date}
              </Header>
            ) : null}
          </Content>
        </Link>
      </Board>
    );
  }

  return (
    <Board>
      <Topbar />
      <Image src={img} />
      <Content>
        <div className="not-footer">
          <Header level={5} style={TitleStyle}>
            {title}
          </Header>
          <Paragraph>{excerpt}</Paragraph>
        </div>
        {date ? (
          <Header level={5} style={DateStyle}>
            {date}
          </Header>
        ) : null}
      </Content>
    </Board>
  );
};

export default UpdateBoard;
